/**
 * 숫자 포맷팅 유틸리티
 */

/**
 * 천자리 구분자 추가
 * @param value - 포맷할 숫자
 * @param decimals - 소수점 자릿수 (기본: 2)
 * @returns 포맷된 문자열
 *
 * @example
 * formatNumber(1234567.89) // "1,234,567.89"
 * formatNumber(1234567.89, 0) // "1,234,568"
 * formatNumber(0.0000005, 8) // "0.0000005"
 */
export function formatNumber(value: number, decimals: number = 2): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

/**
 * 통화 포맷팅 ($1,234.56)
 * @param value - 포맷할 금액
 * @param decimals - 소수점 자릿수 (기본: 2)
 */
export function formatCurrency(value: number, decimals: number = 2): string {
  return `$${formatNumber(value, decimals)}`;
}

/**
 * 암호화폐 수량 포맷팅 (후행 0 제거)
 * @param value - 포맷할 수량
 * @param maxDecimals - 최대 소수점 자릿수 (기본: 8)
 */
export function formatCryptoQuantity(value: number, maxDecimals: number = 8): string {
  // 과학적 표기법 방지
  const fixed = value.toFixed(maxDecimals);
  // 후행 0 제거
  const trimmed = fixed.replace(/\.?0+$/, '');

  // 천자리 구분자 추가
  const parts = trimmed.split('.');
  parts[0] = parseInt(parts[0]).toLocaleString('en-US');

  return parts.join('.');
}

/**
 * 퍼센트 포맷팅
 * @param value - 포맷할 퍼센트 값
 * @param decimals - 소수점 자릿수 (기본: 2)
 */
export function formatPercent(value: number, decimals: number = 2): string {
  const sign = value >= 0 ? '+' : '';
  return `${sign}${formatNumber(value, decimals)}%`;
}
